import { create } from 'zustand';

const initialState = {
  timerPlayingNow: null,
  timerMarquee: null,
  timerPlayingNowSecs: null,
  timerMarqueeSecs: null,
  timerHome: null,
  timerHomeSecs: null,
  sequenceCount: 0,
  playQueueStr: null,
  overlayShowHomeUse: null,
  overlayHideHomeUse: null,
  timerBottomSongbook: null,
  timerBottomHomeUse: null,
};

const timeoutsStore = create((set, get) => ({
  ...initialState,
  reset: () => {
    set(initialState);
  },
  setTimerPlayingNow: (timer) => {
    set({ timerPlayingNow: timer });
  },
  setTimerMarquee: (timer) => {
    set({ timerMarquee: timer });
  },
  setTimerHome: (timer) => {
    set({ timerHome: timer });
  },
  setTimerPlayingNowSecs: (secs) => {
    set({ timerPlayingNowSecs: secs });
  },
  setTimerMarqueeSecs: (secs) => {
    set({ timerMarqueeSecs: secs });
  },
  setTimerHomeSecs: (secs) => {
    set({ timeHomeSecs: secs });
  },
  setSequenceCount: (count) => {
    set({ sequenceCount: count });
  },
  setPlayQueueStr: (str) => {
    set({ playQueueStr: str });
  },
  setOverlayShowHomeUse: (timer) => {
    set({ overlayShowHomeUse: timer });
  },
  setOverlayHideHomeUse: (timer) => {
    set({ overlayHideHomeUse: timer });
  },
  setTimerBottomSongbook: (timer) => {
    set({ timerBottomSongbook: timer });
  },
  setTimerBottomHomeUse: (timer) => {
    set({ timerBottomHomeUse: timer });
  }
}));

export default timeoutsStore;